module.exports = {
  GOLD_UPGRADE: 'GoldIntro'
  GOLD_RECOMMENDATION: 'GoldEarned'
}
